import * as $ from 'jquery';
import Swiper from 'swiper/js/swiper.js'
import ImagesLoaded  from 'Imagesloaded'

export default {
  init() {

    $('html.pc body').tooltip({ selector: '[data-toggle="tooltip"]' })

    // $('body').popover({
    //   selector: '[data-toggle="popover"]',
    //   trigger: 'hover',
    //   placement: 'top'
    // })

    $('.menu-item-has-children > a').click(function(event){

      $(this).parent().toggleClass('is-open')

      $(this).next().slideToggle(200)

      event.preventDefault()
      
    })

    $('.open-sidebar').click(function(event){

      $('html').toggleClass(`show-sidebar show-sidebar-${$(this).data('tab')}`)

      event.preventDefault()      
    })

    $('.woocommerce-form-login .register').click(function(event){
      $('html').addClass('show-sidebar show-sidebar-register')  
    })
    
    $('.site-navigation li:not(.menu-item-has-children) a').click(function(event){
      $('html').removeClass('show-sidebar')  
    })

    $('.sidebar-bg, .sidebar-close').click(function(e){ 
      $('html').removeClass('show-sidebar show-sidebar-menu show-sidebar-cart show-sidebar-login show-sidebar-register show-sidebar-account') 
    })
    
    $('.mobile-navigation > li.menu-item-has-children > a').click(function(event){

      event.preventDefault()
      $(this).next('.sub-menu').slideToggle(400)
      $(this).closest('li').toggleClass('is-open').siblings().removeClass('is-open').find('> .sub-menu').slideUp(400)

    })

    $('.work-item').magnificPopup({
      type: 'image',
      mainClass: 'mfp-with-zoom',
      gallery:{
        enabled:true
      },
      zoom: {
        enabled: true,
        duration: 300,
        easing: 'ease-in-out',
        opener: function(openerElement) {
          return openerElement.is('img') ? openerElement : openerElement.find('img');
        }
      }
    });

    $('.jwd-gallery').each(function() {
      $(this).find('.jwd-gallery-item').magnificPopup({
        type: 'image',
        mainClass: 'mfp-with-zoom',
        gallery:{
          enabled:true
        },
        // zoom: {
        //   enabled: true,
        //   duration: 300,
        //   easing: 'ease-in-out',
        //   opener: function(openerElement) {
        //     return openerElement.is('img') ? openerElement : openerElement.find('img');
        //   }
        // }
      }); 

    });

    $('.mfp-video').magnificPopup({

      //disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-with-zoom',
      preloader: false,
      fixedContentPos: false,
      gallery:{
        enabled: false
      },
      callbacks: {
        // close: function(){
        //   $(window).disablescroll("undo");
        // }
      }

    });

    $('.board-item').click(function(event) {

      $('html, body').stop();

      $('.board-item').not($(this)).removeClass('is-open');

      if (!$(event.target).closest('.board-item-content').length ){
        $(this).toggleClass('is-open');
      }

      if ( $(this).hasClass('is-open') ) {
        $('html, body').animate({
          scrollTop: $(this).offset().top - 100
        },400, 'easeOutQuart');
      }

    });

    $('.service-gallery').each(function(index, el) {

      var t = $(this);

      var service_gallery = new Swiper( t.find('.service-gallery-container')[0], {
        effect: 'fade',
        loop: true,
        autoplay: {
          delay: 4000,
        },
        pagination: {
          el: t.find('.service-gallery-pagination')[0],
          clickable: true,
        },
        spaceBetween: 0,
        autoHeight: true,
        navigation: {
          nextEl: t.find('.next')[0],
          prevEl: t.find('.prev')[0],
        },
        on: {
        },

      });

    });

    $(window).scroll(function (event) {
      const scroll = $(window).scrollTop();
      if(scroll >= 1 ) {
        $('.site-header').addClass('is-sticky')
        $('.sevices-nav').addClass('is-visible')
      }else {
        $('.site-header').removeClass('is-sticky')
        $('.sevices-nav').removeClass('is-visible')
      }

      if(scroll >= 350) {
        $('.goTop').addClass('is-active')
      }else {
        $('.goTop').removeClass('is-active')
      }
    });
  },
  finalize() {

    $('.jwd-lazyload.is-loading').each(function(index, el) {
      var t = $(this);

      ImagesLoaded(t, ()=> {
        var waypoint = new Waypoint({
          element: t,
          handler: () => {
            t.find('img').attr('src', t.find('img').data('src') )
            waypoint.destroy()
            t.removeClass('is-loading')
          },
          offset: '85%'
        })  
      })

    })

  },
};
